<div class="accordion">
  <div class="accordion-title"
       (click)="toggleAccordion()"
       [ngClass]="{'active': isActive}"
       [attr.yp-e2e-id]="generateE2EName('title')">
    {{title}}<span><i class="fal fa-chevron-down"></i></span>
  </div>
  <div class="accordion-content mt-3"
       [ngClass]="{'d-block': isActive}"
       [attr.yp-e2e-id]="generateE2EName('content')">
      <ng-content></ng-content>
  </div>
</div>
